import { mapGetters } from 'vuex'
import config from '@/common/config'
import Environment from '@/shared/constants/core/Environment'
import MediaQueryBreakPoints from '@/shared/constants/core/MediaQueryBreakPoints'
import routeDefinitions from '@/shared/constants/routes/routeDefinitions'
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'

export default {
  computed: {
    ...mapGetters({
      isDebug: 'isDebugModeActive',
      isDarkMode: 'isDarkModeActive',
      hasImpersonateContactId: 'auth/hasImpersonateContactId',
    }),
    isExtraSmall() {
      return this.$mq === MediaQueryBreakPoints.xs.code
    },
    isSmall() {
      return this.$mq === MediaQueryBreakPoints.sm.code
    },
    isMedium() {
      return this.$mq === MediaQueryBreakPoints.md.code
    },
    isLarge() {
      return this.$mq === MediaQueryBreakPoints.lg.code
    },
    isExtraLarge() {
      return this.$mq === MediaQueryBreakPoints.xl.code
    },
    isSmallOrLower() {
      return this.isSmall || this.isExtraSmall
    },
    isMediumOrLower() {
      return this.isSmall || this.isExtraSmall || this.isMedium
    },
    isLargeOrLower() {
      return this.isSmall || this.isExtraSmall || this.isMedium || this.isLarge
    },
    isSmallOrHigher() {
      return this.isSmall || this.isMedium || this.isLarge || this.isExtraLarge
    },
    isMediumOrHigher() {
      return this.isMedium || this.isLarge || this.isExtraLarge
    },
    isLargeOrHigher() {
      return this.isLarge || this.isExtraLarge
    },
    isMobileViewPort() {
      return this.isExtraSmall || this.isSmall || this.isMedium
    },
    isDev() {
      return config.get('env') === Environment.development
    },
    isImpersonating() {
      return this.hasImpersonateContactId
    },
    heightOfDevBar() {
      return this.isDev ? 24 : 0 // in pixels
    },
    routeDefinitions() {
      return routeDefinitions
    },
    colorClass() {
      return VuetifyColourClass
    },
    textClass() {
      return VuetifyTextClass
    },
  },
}
